import { ExtendedImage } from '../extensions';

export function configureImage() {
  return ExtendedImage.configure({
    allowBase64: true,
    inline: true,
  });
}
